import { Divider } from "@mui/material";
import {
  Box,
  FlexColBox,
  OverlayScrollbarWrapper,
} from "../../../common/components";
import { STUDIO_TOOLBAR_HEIGHT } from "../../../components/StudioToolbar/StudioToolbar";
import { useStudio } from "../../../context/Studio/useStudio";
import { createStyles, palette, spacing } from "../../../styles/theme";
import { useThemeBreakpoints } from "../../../utils/themeUtils";
import { Decorations } from "./Decorations";
import { ModelSwitcher } from "./ModelSwitcher";
import { SpecElement } from "./SpecElement";
import StudioLeftSidebarSkeleton from "./StudioLeftSidebarSkeleton";
import { WorkWithADesignerMessage } from "../../../components/WorkWithADesignerMessage";
const styles = createStyles({
  wrapper: {
    height: "100%",
    maxHeight: `calc(100dvh - ${STUDIO_TOOLBAR_HEIGHT})`,
    "&>div": {
      height: "100%",
    },
    position: "relative",
  },
  container: {
    minHeight: { xs: "auto", lg: `calc(100dvh - ${STUDIO_TOOLBAR_HEIGHT})` },
    display: "flex",
    flexDirection: "column",
    py: { xs: spacing.mediumMobile, lg: spacing.mediumDesktop },
    pl: { xs: spacing.mediumMobile, lg: spacing.mediumDesktop },
    pr: { xs: "0", lg: spacing.mediumDesktop },
    alignItems: "center",
    minWidth: { xs: "100%", lg: "324px" },
    maxWidth: { xs: "100vw", lg: "324px" },
    borderRight: { xs: "none", lg: `1px solid ${palette.grey.lightGrey}` },
    gap: { xs: spacing.regularMobile, lg: spacing.regularDesktop },
    height: "100%",
  },
});

const StudioLeftSidebar = () => {
  const {
    designState: {
      onDesignChange,
      partsDefinition,
      deprecatedDesignItems,
      colorBleedingItems,
      siblingProducts,
      isPartsDefinitionLoading,
      colorEndOfLifeItems,
    },
    isLoading,
    productName,
  } = useStudio();

  const { isMobile } = useThemeBreakpoints();

  if (isLoading || isPartsDefinitionLoading) {
    return <StudioLeftSidebarSkeleton />;
  }

  return (
    <Box sx={styles.wrapper}>
      <OverlayScrollbarWrapper
        options={{
          scrollbars: {
            visibility: isMobile ? "visible" : "auto",
          },
        }}
      >
        <Box sx={styles.container}>
          <FlexColBox
            gap={{ xs: spacing.wrapperMobile, lg: spacing.regularDesktop }}
            fullWidth
            flexDirection={{ xs: "row", lg: "column" }}
            pb={{ xs: undefined, lg: "32px" }}
          >
            <ModelSwitcher
              siblingProducts={siblingProducts ?? []}
              currentProductName={productName}
              onDesignChange={onDesignChange}
            />
            {isMobile && !!siblingProducts?.length && (
              <Divider orientation="vertical" />
            )}
            <FlexColBox
              gap={{ xs: spacing.wrapperMobile, lg: spacing.xsDesktop }}
              flexDirection={{ xs: "row", lg: "column" }}
              alignItems={{ xs: "center", lg: undefined }}
            >
              {partsDefinition.map((p, index) => (
                <SpecElement
                  partDefinition={p}
                  key={index}
                  deprecatedDesignItems={deprecatedDesignItems?.filter(
                    (d) => d.partName === p.name
                  )}
                  colorBleedingItems={colorBleedingItems?.filter(
                    (d) => d.partName === p.name
                  )}
                  colorEndOfLifeItems={colorEndOfLifeItems?.filter(
                    (d) => d.partName === p.name
                  )}
                />
              ))}
            </FlexColBox>
            {isMobile && <Divider orientation="vertical" />}
            <Decorations />
          </FlexColBox>
          {!isMobile && <WorkWithADesignerMessage />}
        </Box>
      </OverlayScrollbarWrapper>
    </Box>
  );
};

export default StudioLeftSidebar;
